export const capitalizeFirstLetter = (word) => {
    if (!word) return
    return word.charAt(0).toUpperCase() + word.slice(1);
}

export const classNameJoiner = (classes) => {
    return Object.entries(classes)
        .filter(([key, value]) => value)
        .map(([key]) => key)
        .join(' ');
};

export const isGoogleDriveUrl = (url) => {
    const regex = /^https?:\/\/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)\/preview$/;
    return regex.test(url);
}

export const  compareObjects = (obj1, obj2) => {
    const previousValues = {};
    const newValues = {};
  
    for (let key in obj2) {
      if (obj1[key] !== obj2[key]) {
        previousValues[key] = obj1[key];
        newValues[key] = obj2[key];
      }
    }
  
    return {
      previous: previousValues,
      new: newValues,
    };
  }